import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      className="min-h-screen py-16 px-6"
      style={{ backgroundColor: "#0f172a", color: "white" }}
    >
      <div className="max-w-4xl mx-auto">
        <h1
          className="text-4xl font-bold mb-8"
          style={{ color: "#D4AF37" }}
        >
          Privacy Policy
        </h1>

        <p className="mb-6">
          At <b>Guru Maa Pooja Sharma</b>, we value your privacy and are
          committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
        </p>

        <hr className="my-6 border-gray-600" />

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          1. Information We Collect
        </h2>
        <p>We may collect the following information:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Name</li>
          <li>Phone number</li>
          <li>Email address</li>
          <li>Any details you provide related to your problem (love, marriage, career, etc.)</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          2. How We Use Your Information
        </h2>
        <p>We use your information to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Provide astrology consultation services</li>
          <li>Contact you via call, WhatsApp, or email</li>
          <li>Respond to your queries and requests</li>
          <li>Improve our services and user experience</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          3. No Middleman Policy
        </h2>
        <p>
          We ensure <b>direct consultation with Guru Maa</b>. Your information is not shared with any third-party agents or intermediaries.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          4. Data Protection
        </h2>
        <p>
          We take appropriate security measures to protect your personal data from unauthorized access, misuse, or disclosure.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          5. Sharing of Information
        </h2>
        <p>
          We do <b>not sell, trade, or rent</b> your personal information to others.
        </p>
        <p>
          We may only share information if required by law.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          6. Cookies
        </h2>
        <p>
          Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          7. Third-Party Services
        </h2>
        <p>
          We may use third-party tools (such as Google Ads, analytics tools) to improve our services. These services may collect non-personal data as per their policies.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          8. Your Consent
        </h2>
        <p>
          By using our website, you consent to our Privacy Policy.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          9. Contact Us
        </h2>
        <p>
          If you have any questions regarding this Privacy Policy, you can contact us:
        </p>
        <p className="mt-2">
          <b>Guru Maa Pooja Sharma</b> <br />
          Website: https://gurumaapooja.com <br />
          Phone/WhatsApp: +971 541873527
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3" style={{ color: "#D4AF37" }}>
          10. Updates to This Policy
        </h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;